import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
// import { CheckOutlined } from '@ant-design/icons';
import { ReactComponent as CheckCircle2 } from '../../static/img/check-circle-2.svg';
import './RegistrationSuccessModal.css';

function RegistrationSuccessModal({ visible, onClose, title, messages, width }) {
  const defaultTitle = 'Registration Successful';
  const defaultMessages =
    'Your registration was successfully submitted. You will receive an email notification with further instructions.';
  const displayTitle = title ?? defaultTitle;
  const displayMessages = messages ?? defaultMessages;

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      maskClosable
      width={width ?? 400}
      className="registration-success-modal"
      maskStyle={{ backdropFilter: 'blur(4px)' }}
    >
      <div className="registration-success-modal-content">
        <div className="registration-success-modal-icon">
          <CheckCircle2 />
        </div>
        <h3 className="registration-success-modal-title">{displayTitle}</h3>
        <p className="registration-success-modal-message">{displayMessages}</p>
      </div>
    </Modal>
  );
}

RegistrationSuccessModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  messages: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  width: PropTypes.number,
};

export default RegistrationSuccessModal;
